import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs';
import { RestApiBaseService } from '../../core/http/rest-api-base.service';
import type { ApiResponse } from '../../core/models/api-response.model';

@Injectable({ providedIn: 'root' })
export class ConfigListingRestApiService extends RestApiBaseService {

  private readonly http = inject(HttpClient);

  // POST /api/v2/config-listings
  createUpdate(body: Record<string, unknown>) {
    return this.http
      .post<ApiResponse<unknown>>(`${this.v2Base}/config-listings`, body)
      .pipe(
        map(res => res.data ?? null),
        catchError(err => this.handleError(err))
      );
  }

  // POST /api/v2/config-listings:resetDefaults
  resetDefaults() {
    return this.http
      .post<ApiResponse<unknown>>(`${this.v2Base}/config-listings:resetDefaults`, {})
      .pipe(
        map(res => res.data ?? null),
        catchError(err => this.handleError(err))
      );
  }

  // POST /api/v2/config-listings:clearAllFilters
  clearAllFilters() {
    return this.http
      .post<ApiResponse<unknown>>(`${this.v2Base}/config-listings:clearAllFilters`, {})
      .pipe(
        map(res => res.data ?? null),
        catchError(err => this.handleError(err))
      );
  }

  // POST /api/v2/config-listings:clearTempPresets
  clearTempPresets() {
    return this.http
      .post<ApiResponse<unknown>>(`${this.v2Base}/config-listings:clearTempPresets`, {})
      .pipe(
        map(res => res.data ?? null),
        catchError(err => this.handleError(err))
      );
  }

  // POST /api/v2/config-listings/:type:changeColumnVisibility
  changeColumnVisibility(type: string, columnId: string) {
    return this.http
      .post<ApiResponse<unknown>>(
        `${this.v2Base}/config-listings/${type}:changeColumnVisibility`,
        { column_id: [columnId] }
      )
      .pipe(
        map(res => res.data ?? null),
        catchError(err => this.handleError(err))
      );
  }

  // POST /api/v2/config-listings/:type/presets
  upsertPreset(type: string, body: Record<string, unknown>) {
    return this.http
      .post<ApiResponse<unknown>>(
        `${this.v2Base}/config-listings/${type}/presets`,
        body
      )
      .pipe(
        map(res => res.data ?? null),
        catchError(err => this.handleError(err))
      );
  }

  // DELETE /api/v2/config-listings/:type/presets/:presetId
  deletePreset(type: string, presetId: string) {
    return this.http
      .delete<ApiResponse<unknown>>(
        `${this.v2Base}/config-listings/${type}/presets/${presetId}`
      )
      .pipe(
        map(res => res.data ?? null),
        catchError(err => this.handleError(err))
      );
  }

  // DELETE /api/v2/config-listings/:type
  delete(type: string) {
    return this.http
      .delete<ApiResponse<unknown>>(`${this.v2Base}/config-listings/${type}`)
      .pipe(
        map(res => res.data ?? null),
        catchError(err => this.handleError(err))
      );
  }
}
